import React from 'react'
import { useSelector } from 'react-redux'
import { useScrollToSection } from "../../hooks/useScrollToSection";
import InfoSection from './AboutUsUtils/InfoSection'
import './AboutUs.css'
import TopSection from './AboutUsUtils/TopSection'
import Footer from '../Footer/Footer'

function AboutUs() {
  useScrollToSection();

  const aboutUsContent = useSelector(state => state.AboutUsContent);

  return (
    <>
    <TopSection/>
    <div className='aboutus-container' style={{marginTop: '60px'}}>
      
      {aboutUsContent && aboutUsContent.length > 0 ? (
        aboutUsContent.map((content, index) => (
          <React.Fragment key={index}>
            <InfoSection
              heading={content.Title}
              content={content.Content}
              image={content.AboutUsImage}
              showButton={false}
              showAccordion={false}
            />
            {index < aboutUsContent.length - 1 && <div className='section-divider' />}
          </React.Fragment>
        ))
      ) : (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '400px',
          padding: '40px'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #00238a',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginBottom: '20px'
          }}></div>
          <p style={{
            fontSize: '20px',
            color: '#333333',
            fontFamily: 'Scandinavian New, Arial, sans-serif',
            fontWeight: '400'
          }}>Loading About Us content...</p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      )}

      <div style={{marginTop:"40px", borderTop: "1px solid #E0E0E0"}}>
        <Footer/>
      </div>

    </div>
    </>
  )
}

export default AboutUs
